/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**********************************************!*\
  !*** ./src/assets/js/whats-inside-slider.js ***!
  \**********************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var WhatsInsideSlider = /*#__PURE__*/function (_HTMLElement) {
  _inherits(WhatsInsideSlider, _HTMLElement);

  var _super = _createSuper(WhatsInsideSlider);

  function WhatsInsideSlider() {
    var _this;

    _classCallCheck(this, WhatsInsideSlider);

    _this = _super.call(this);
    _this.leftSlider = _this.querySelector('.whats-inside__grid-left-slider');
    _this.rightSlider = _this.querySelector('.whats-inside__right-slider');
    _this.nextArrow = _this.querySelector('.swiper-button-next');
    _this.prevArrow = _this.querySelector('.swiper-button-prev');
    _this.activeSlider = null;
    _this.activeThumbSlider = null;
    _this.viewMoreTogglesDesktop = _this.querySelector('.view-more-toggle-desktop') ? _this.querySelectorAll('.view-more-toggle-desktop') : null;
    _this.viewMoreTogglesMobile = _this.querySelector('.view-more-toggle-mobile') ? _this.querySelectorAll('.view-more-toggle-mobile') : null;
    return _this;
  }

  _createClass(WhatsInsideSlider, [{
    key: "initSlider",
    value: function initSlider() {
      var _this2 = this;

      if (this.activeThumbSlider) {
        this.activeThumbSlider.swiper.destroy();
      }

      if (this.activeSlider) {
        this.activeSlider.swiper.destroy();
      }

      var thumb_options = {
        slidesPerView: 1,
        spaceBetween: 0,
        autoHeight: true
      };
      var main_options = {
        slidesPerView: 1,
        autoHeight: true,
        spaceBetween: 0,
        navigation: {
          nextEl: this.nextArrow,
          prevEl: this.prevArrow
        }
      };

      var initSwiper = function initSwiper() {
        if (typeof Swiper === 'undefined') {
          return false;
        }

        _this2.activeThumbSlider = new Swiper(_this2.rightSlider, thumb_options);
        _this2.activeSlider = new Swiper(_this2.leftSlider, main_options);
        _this2.activeThumbSlider.controller.control = _this2.activeSlider;
        _this2.activeSlider.controller.control = _this2.activeThumbSlider;

        _this2.activeSlider.on('init slideChange', function () {
          setTimeout(function () {
            _this2.updateNavButtonsPosition();
          }, 200);
        });

        setTimeout(function () {
          _this2.updateNavButtonsPosition();
        }, 1000);
        return true;
      };

      var swiperCheckInterval = setInterval(function () {
        if (initSwiper()) {
          clearInterval(swiperCheckInterval);
        }
      }, 100);
    }
  }, {
    key: "updateNavButtonsPosition",
    value: function updateNavButtonsPosition() {
      var activeImageHeight = this.querySelector('.whats-inside__grid-left-slider .swiper-slide.swiper-slide-active .whats-inside__left-image').offsetHeight;
      var buttonPosition = activeImageHeight / 2;

      if (this.nextArrow && this.prevArrow) {
        this.nextArrow.style.top = "".concat(buttonPosition, "px");
        this.prevArrow.style.top = "".concat(buttonPosition, "px");
      }
    }
  }, {
    key: "initListenersDesktop",
    value: function initListenersDesktop() {
      this.viewMoreTogglesDesktop.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var x = toggle.closest("view_more-grid-desktop");

          if (x.classList.contains("collapsed")) {
            x.classList.remove("collapsed");
          } else {
            x.classList.add("collapsed");
          }
        });
      });
    }
  }, {
    key: "initListenersMobile",
    value: function initListenersMobile() {
      this.viewMoreTogglesMobile.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var x = toggle.closest("view_more-grid-desktop");

          if (x.classList.contains("collapsed")) {
            x.classList.remove("collapsed");
          } else {
            x.classList.add("collapsed");
          }
        });
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initSlider(); // probably we'll need this in future
      // if (this.viewMoreTogglesDesktop) {
      //     this.initListenersDesktop();
      // }
      // if (this.viewMoreTogglesMobile) {
      //     this.initListenersMobile();
      // }
    }
  }]);

  return WhatsInsideSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (customElements.get('whats-inside-slider') === undefined) {
  customElements.define("whats-inside-slider", WhatsInsideSlider);
}
/******/ })()
;